import Conditional from 'decorators/conditional';
import Mobile from './index.mobile';
import Desktop from './index.desktop';

export default Conditional({
  desktop: Desktop,
  default: Mobile,
});
